$shm_hitalama_map_widget_float_code_panel $mol_view
	no_crdt false
	code_download_blob null
	code_download_file_name \
	template_dictionary *
	template_selected? \
	enabled? true
	run_click? null
	sub <= panel_content /
	No_crdt_label $mol_text
		text \No-CRDT
	Download $mol_button_download
		title \Скачать
		blob <= code_download_blob null
		file_name <= code_download_file_name \
	Templates $mol_select
		hint \Шаблоны
		trigger_content /
			<= Templates_icon $mol_icon_code_braces
			\Шаблоны
		dictionary <= template_dictionary *
		value? <=> template_selected? \
	Autorun_enabled $mol_check_box
		title \Автозапуск
		checked? <=> enabled? true
	Run $mol_button_minor
		sub /
			<= Run_icon $mol_icon_play
		click? <=> run_click? null
